module.exports = __webpack_public_path__ + "img/t1-9.61b46988.png";